import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api from '../../../utils/api';
import { STATUS } from '../../../utils/status';
import { AnalyticsCompletedState, AnalyticsPayload } from '../../interfaces/interface';
import extraReducers from '../../extraReducers/analyticsCompletedExtraReducer';

const initialState: AnalyticsCompletedState = {
  analyticsCompleted: {
    count: undefined,
    results: []
  },
  error: null,
  getStatus: STATUS.NOT_STARTED,
  createMessage: "",
};

export const getCompletedAnalytics = createAsyncThunk(
  'project/qa-analytics/overview/taskbydate/get',
  async (payload: AnalyticsPayload = { association_type: '' }, thunkAPI) => {
    try {
      const { search, page, pageSize, sort_by, sort_order, project_id, association_type, start_date, end_date, granularity } = payload;
      const queryString = new URLSearchParams({
        ...(search && { search }),
        ...(page && { page: page.toString() }),
        ...(pageSize && { page_size: pageSize.toString() }),
        ...(sort_by && { sort_by }),
        ...(sort_order && { sort_order }),
        ...(project_id && { project_id }),
        ...(start_date && { start_date }),
        ...(end_date && { end_date }),
        ...(granularity && { granularity }),
        tab: 'task_by_date',
        ...(association_type && { association_type }),

      }).toString();
      const response = await api.get(`project/qa-analytics/overview/?${queryString}`);
      const { status, data } = response;
      if (status === 200) {
        const mappedData = data?.data || data;
        return {
          count: mappedData?.count ?? 0,
          results: mappedData?.results || [],
        };
      } else {
        return thunkAPI.rejectWithValue({ response, data });
      } 
    } catch (error: any) {
      if (error.response) {
        const { status, data } = error.response;
        let errorMessage = `Request failed with status ${status}`;
        if (data && data.message) {
          errorMessage += `: ${data.message}`;
          console.log({ errorMessage });
        }
        return thunkAPI.rejectWithValue({ message: errorMessage });
      } else if (error.request) {
        return thunkAPI.rejectWithValue({ message: 'No response received' });
      } else {
        return thunkAPI.rejectWithValue({ message: error.message });
      }
    }
  }
);

const analyticsCompletedSlice = createSlice({
  name: 'analyticsCompleted',
  initialState,
  reducers: {
  },
  extraReducers
});

export default analyticsCompletedSlice.reducer;
